import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BaseIconComponent } from '../base-icon.component'

@Component({
  selector: 'app-icon-ai-chat-bold',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_29745_34360)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.66667 12.1938C1.95933 12.1938 1.28133 12.4692 0.781333 12.9603C0.280667 13.4508 0 14.1159 0 14.8098V16.8062C0 17.5 0.280667 18.1651 0.781333 18.6556C1.28133 19.1468 1.95933 19.4221 2.66667 19.4221H4C4.73667 19.4221 5.33333 18.8368 5.33333 18.1141V13.5018C5.33333 12.7792 4.73667 12.1938 4 12.1938C4 10.6328 4.632 9.1358 5.75733 8.03188C6.88267 6.92795 8.40867 6.30797 10 6.30797C13.3133 6.30797 16 8.94353 16 12.1938C15.2633 12.1938 14.6667 12.7792 14.6667 13.5018V18.1141C14.6667 18.8368 15.2633 19.4221 16 19.4221V20.7301C16 21.0911 15.7013 21.3841 15.3333 21.3841H13.3333C13.3333 20.6614 12.7367 20.0761 12 20.0761H10.5263C9.78965 20.0761 9.19298 20.6614 9.19298 21.3841V22.692C9.19298 23.4147 9.78965 24 10.5263 24H12C12.7367 24 13.3333 23.4147 13.3333 22.692H15.3333C16.438 22.692 17.3333 21.8137 17.3333 20.7301V19.4221C18.0407 19.4221 18.7187 19.1468 19.2187 18.6556C19.7193 18.1651 20 17.5 20 16.8062V14.8098C20 14.1159 19.7193 13.4508 19.2187 12.9603C18.7187 12.4692 18.0407 12.1938 17.3333 12.1938C17.3333 8.22088 14.05 5 10 5C8.05533 5 6.19 5.75797 4.81467 7.10714C3.43933 8.45631 2.66667 10.2862 2.66667 12.1938Z"
          fill="url(#paint0_linear_29745_34360)"
        />
        <path
          d="M19.5 0L20.391 3.60905L24 4.5L20.391 5.39095L19.5 9L18.609 5.39095L15 4.5L18.609 3.60905L19.5 0Z"
          fill="url(#paint1_linear_29745_34360)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_29745_34360"
          x1="16.8421"
          y1="24.826"
          x2="4.33332"
          y2="5.3068"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163477" stop-color="var(--color-primary-600)" style="stop-opacity:1;" />
          <stop offset="0.598558" stop-color="var(--color-primary-500)" style="stop-opacity:1;" />
          <stop offset="1" stop-color="var(--color-info-500)" style="stop-opacity:1;" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_29745_34360"
          x1="22.5789"
          y1="9.39128"
          x2="16.5321"
          y2="0.427251"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163477" stop-color="var(--color-primary-600)" style="stop-opacity:1;" />
          <stop offset="0.598558" stop-color="var(--color-primary-500)" style="stop-opacity:1;" />
          <stop offset="1" stop-color="var(--color-info-500)" style="stop-opacity:1;" />
        </linearGradient>
        <clipPath id="clip0_29745_34360">
          <rect width="24" height="24" fill="white" style="fill:white;fill-opacity:1;" />
        </clipPath>
      </defs>
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiChatBoldIconComponent extends BaseIconComponent {}
